export const OPERACIONES_DEFAULT_PER_PAGE = 10;

export const OPERACIONES_REQUEST_TIMEOUT = 30000;

export const OPERACIONES_BASE_URL =
  process.env.VUE_APP_SERVICE_SYSTEM_LIQUIDACIONES_BASE ||
  process.env.VUE_APP_REPORT_VTEX_BASE;

export const OPERACIONES_PATHS = {
  periodosCatalogo: "/hp/service-system/v1/liquidaciones/periodos/catalogo",
  operaciones: "/hp/service-system/v1/liquidaciones/operaciones",
  guardarOc: "/hp/service-system/v1/liquidaciones/operaciones/guardar-oc",
  guardarOcMasivo:
    "/hp/service-system/v1/liquidaciones/operaciones/guardar-oc-masivo",
  validarOcMasivo:
    "/hp/service-system/v1/liquidaciones/operaciones/validar-oc-masivo",
  cargarPdfOcMasivo:
    "/hp/service-system/v1/liquidaciones/operaciones/cargar-pdf-oc-masivo",
  cargarPdfOc:
    "/hp/service-system/v1/liquidaciones/operaciones/cargar-pdf-oc",
};

export const OPERACIONES_ESTADO_OPTIONS = [
  { value: "PENDIENTE", text: "Pendiente" },
  { value: "POR_TRABAJAR", text: "Por trabajar" },
  { value: "EN_PROCESO", text: "En proceso" },
  { value: "COMPLETADO", text: "Completado" },
];

export const MESSAGES = {
  PAGE_TITLE: "Operaciones",
  SECTION_TITLE: "Operaciones",
  EMPTY_TABLE: "No hay registros para mostrar.",
  LOADING: "Cargando...",
  LOAD_ERROR: "No se pudo cargar la información de operaciones.",
  LOAD_TIMEOUT_ERROR: "La solicitud tardó demasiado. Intente nuevamente.",
  MODAL_TITLE: "Actualizar registro",
  SAVE_SUCCESS: "OC y Migo guardados correctamente.",
  SAVE_ERROR: "Error al guardar OC y Migo.",
  SAVE_BUTTON: "Guardar",
  CANCEL_BUTTON: "Cancelar",
  EXPORT_BUTTON: "Exportar",
  IMPORT_BUTTON: "Cargar OC/Migo",
  UPLOAD_PDF_BUTTON: "Cargar PDFs OC",
  UPLOAD_PDF_MODAL_TITLE: "Carga masiva de PDFs de Órdenes de Compra (OC)",
  IMPORT_SUCCESS: "Carga masiva procesada correctamente.",
  IMPORT_ERROR: "Error al procesar el archivo.",
  IMPORT_NO_ITEMS: "No se encontraron registros válidos en el archivo.",
  IMPORT_WIZARD_TITLE: "Carga masiva de OC / Migo",
  IMPORT_STEP_SELECT_TITLE: "1. Descarga la plantilla y selecciona tu archivo",
  IMPORT_STEP_PREVIEW_TITLE: "2. Revisa los registros antes de confirmar",
  IMPORT_STEP_RESULT_TITLE: "3. Resultado de la carga",
  DOWNLOAD_TEMPLATE_BUTTON: "Descargar plantilla",
  SELECT_FILE_BUTTON: "Seleccionar archivo",
  CONFIRM_IMPORT_BUTTON: "Confirmar carga",
  DOWNLOAD_ERRORS_BUTTON: "Descargar reporte de errores",
  IMPORT_BACK_BUTTON: "Volver",
  IMPORT_CLOSE_BUTTON: "Cerrar",
  IMPORT_NEW_BUTTON: "Cargar otro archivo",
  IMPORT_REMOVE_ROW: "Quitar",
  IMPORT_VALID_ROWS_LABEL: "válidas",
  IMPORT_INVALID_ROWS_LABEL: "con error",
  IMPORT_NOT_SENT_SUFFIX: "no se enviaron y quedaron fuera de la carga.",
  IMPORT_UNSAVED_CONFIRM:
    "Tienes una carga sin confirmar. Si sales ahora, se perderán los cambios revisados. ¿Deseas salir de todas formas?",
  IMPORT_NOT_FOUND_SUFFIX:
    "no encontraron una OS que coincida (RUC + Tienda + Material) en este periodo.",
  IMPORT_VALIDATING: "Validando contra el periodo...",
  IMPORT_VALIDATE_ERROR:
    "No se pudo validar contra el servidor. Se muestran solo las validaciones de campos; el sistema revalidará al confirmar.",
  REVALIDATE_BUTTON: "Revalidar"
};

export function getOperacionesTableFields() {
  return [
    {
      key: "razonSocial",
      label: "Razón Social",
      thClass: "text-center",
      tdClass: "text-left",
      excelHidden: true,
    },
    {
      key: "ruc",
      label: "RUC",
      thClass: "text-center",
      tdClass: "text-center",
    },
    {
      key: "codigoTienda",
      label: "Cód. Tienda",
      thClass: "text-center",
      tdClass: "text-center",
      excelHidden: true,
    },
    {
      key: "tienda",
      label: "Tienda",
      thClass: "text-center",
      tdClass: "text-left",
    },
    {
      key: "conceptoOc",
      label: "Concepto OC",
      thClass: "text-center",
      tdClass: "text-left",
      excelHidden: true,
    },
    {
      key: "indicadorImputacion",
      label: "Indicador de Imputación",
      thClass: "text-center",
      tdClass: "text-center",
      excelHidden: true,
    },
    {
      key: "material",
      label: "Material",
      thClass: "text-center",
      tdClass: "text-center",
    },
    {
      key: "indicarTextoOc",
      label: "Indicar Texto OC",
      thClass: "text-center",
      tdClass: "text-left",
      excelHidden: true,
    },
    {
      key: "montoOcSinIgv",
      label: "Monto OC (sin IGV)",
      thClass: "text-center",
      tdClass: "text-right",
      excelHidden: true,
    },
    {
      key: "centroDeCostos",
      label: "Centro de Costos",
      thClass: "text-center",
      tdClass: "text-center",
      excelHidden: true,
    },
    {
      key: "codigoIgv",
      label: "Código de IGV",
      thClass: "text-center",
      tdClass: "text-center",
      excelHidden: true,
    },
    {
      key: "moneda",
      label: "Moneda",
      thClass: "text-center",
      tdClass: "text-center",
      excelHidden: true,
    },
    {
      key: "status",
      label: "Status",
      thClass: "text-center",
      tdClass: "text-center operaciones-status-cell",
      excelHidden: true,
    },
    {
      key: "numeroOc",
      label: "Numero OC",
      thClass: "text-center",
      tdClass: "text-center",
    },
    {
      key: "migo",
      label: "Migo",
      thClass: "text-center",
      tdClass: "text-center",
    },
    {
      key: "archivoPdf",
      label: "PDF OC",
      thClass: "text-center",
      tdClass: "text-center",
    },
  ];
}
export function getOperacionesExportFields() {
  return [
    
    { key: "marcaTemporal", label: "Marca Temporal" },
    { key: "ruc", label: "RUC" },
    { key: "razonSocial", label: "Razón social" },
    { key: "tienda", label: "Tienda" },
    { key: "conceptoOc", label: "Concepto OC" },
    { key: "indicadorImputacion", label: "Imputación" },
    { key: "material", label: "Material" },
    { key: "indicarTextoOc", label: "Nomenclatura" },
    { key: "montoOcSinIgv", label: "Monto OC sin IGV" },
    { key: "centroDeCostos", label: "Centro de Costos" },
    { key: "codigoIgv", label: "Código de IGV" },
    { key: "moneda", label: "Moneda" },
    { key: "numeroOc", label: "OC" },
    { key: "migo", label: "MIGO" },
    { key: "idLiquidacionCab", label: "ID Liquidación" },   
    { key: "codigoTienda", label: "Cód. Tienda" },    
    { key: "llave", label: "Llave" },
    { key: "noOc", label: "No OC" },
    { key: "cabePos", label: "Cabe./Pos." },     
  ];
}
export function getOperacionesEstadoLabel(value) {
  const option = OPERACIONES_ESTADO_OPTIONS.find(
    (item) => item.value === value,
  );
  return option?.text || value || "-";
}
export const OPERACIONES_FILTER_SLOTS = ["periodo", "proveedor"];

export const OPERACIONES_MESSAGES = {
  ...MESSAGES,
  FILTERS_TITLE: "Operaciones",
  FILTER_CORTE_LABEL: "Periodo de Liquidación",
  FILTER_PROVEEDOR_LABEL: "Proveedor",
  SEARCH_BUTTON: "Buscar",
  CLEAR_BUTTON: "Limpiar",
};

export function getDefaultPeriodoFilterOptions() {
  return [{ value: 0, text: "-- Seleccione un periodo --" }];
}
export function getDefaultProveedorFilterOptions() {
  return [{ value: 0, text: "Elige una opción", disabled: true }];
}
